'use client';

import Script from 'next/script';
import { useCookieConsent } from '@/features/cookie-consent';


const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;


export function GoogleAnalytics () {
    const { consent } = useCookieConsent();

    const isGranted = consent?.analytics === true;

    if (!GA_MEASUREMENT_ID || !isGranted) {
        return null;
    }

    return (
        <>
            <Script
                strategy='afterInteractive'
                src={ `https://www.googletagmanager.com/gtag/js?id=${ GA_MEASUREMENT_ID }` }
            />

            <Script
                id='google-analytics'
                strategy='afterInteractive'
            >
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){ dataLayer.push(arguments); }
                    gtag('js', new Date());
                    gtag('config', '${ GA_MEASUREMENT_ID }');
                `}
            </Script>
        </>
    );
}
